"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "roe-volciano": {
    "a01196ce": [{
      "hkey": "278fadd4",
      "slug": "roe-volciano",
      "name": "Roè Volciano",
      "primary": true,
      "skipSearch": false
    }],
    "agneto": [{
      "hkey": "278fadd4",
      "slug": "roe-volciano",
      "name": "Roè Volciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3fae485b": [{
      "hkey": "278fadd4",
      "slug": "roe-volciano",
      "name": "Roè Volciano",
      "primary": true,
      "skipSearch": false
    }],
    "rucco": [{
      "hkey": "278fadd4",
      "slug": "roe-volciano",
      "name": "Roè Volciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;